export default __webpack_public_path__ + "img/6ab874f8192acca28e424cfe3f5b91f4.png";